import { z } from "zod"

// Definition of the DocumentSection schema
export const documentSectionSchema = z.object({
  /** Unique ID of this document section */
  documentSectionId: z.number().int(),
  /** Unique ID of the document associated with this section */
  documentId: z.number().int(),
  /** Title of the document section */
  sectionHeading: z.string(),
  /** Possible values are SERVICE,
   * TARIFF, CLIMATE_ZONE, or UTILITY_CLIMATE_ZONE */
  sectionType: z.enum([
    `SERVICE`,
    `TARIFF`,
    `CLIMATE_ZONE`,
    `UTILITY_CLIMATE_ZONE`,
  ]),
  /** The page number of the document this section starts on */
  startPage: z.number().int(),
  /** The type of customer this document section concerns */
  customerClass: z.enum([`GENERAL`, `RESIDENTIAL`, `SPECIAL_USE`, `PROPOSED`]),
  /** Whether this document has been revised from the original */
  revised: z.boolean(),
  /** Unique ID of the document section for the
   * previous version of this tariff */
  priorDocumentSectionId: z.number().int().optional(),
})

export type DocumentSection = z.infer<typeof documentSectionSchema>
